<script>
	export default {
		name: "statisticssection"
	}
</script>

<template>
	<div class="row pricing">
		<div class="container">
			<section class="section" id="porque">
				<div class="statistics-title">
					<h2>
						Por que
						Voto Legal?
					</h2>
				</div>
				<div class="statistics-boxes-wrap">
					<div class="statistics-box">
						<div class="statistic-box-title">
							<h3 class="big">
                R$ 2.5
							</h3>
							<h3>
                milhões arrecadados
							</h3>
						</div>
						<div class="statistic-box-text">
							<p>
                Segurança e agilidade no processamento de pagamentos
							</p>
						</div>
					</div>
					<div class="statistics-box">
						<div class="statistic-box-title">
							<h3 class="big">
                +500
							</h3>
							<h3>
                campanhas
                realizadas
							</h3>
						</div>

						<div class="statistic-box-text">
							<p>
                Suporte especializado desde a mobilização até a prestação de contas
							</p>
						</div>
					</div>
					<div class="statistics-box">
						<div class="statistic-box-title">
							<h3 class="big">
                15 mil
							</h3>
              <h3>
                doadores atendidos
              </h3>
						</div>
						<div class="statistic-box-text">
							<p>
                Confiança e praticidade no processo de doação e emissão de recibos.
							</p>
						</div>
					</div>
          <div class="statistics-box">
						<div class="statistic-box-title">
              <h3 class="big">
                100%
              </h3>
              <h3>
                das contas aprovadas em 2018
              </h3>
						</div>
						<div class="statistic-box-text">
							<p>
                A prestação de contas do financiamento coletivo feita com tecnologia e seriedade por especialistas no assunto.
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.pricing {
		position: relative;
		background-color: rgb(30, 91, 102);
		color: white;
		text-align: center;
		width: 100%;
	}

	.pricing .section {
    display: flex;
    flex-wrap: wrap;
		padding-top: 3.125rem;
		padding-bottom: 3.125rem;


		@media (min-width: 768px) {
			padding-top: 4.375rem;
			padding-bottom: 0;
		}
		@media (min-width: 991px) {
			padding-top: 6.25rem;
			padding-bottom: 0;
		}

		&::after {
			content: "";
			display: table;
			clear: both;
		}
	}

	.statistics-title {
		margin-bottom: 6em;

		@media (min-width: 768px) {
			margin-top: -3em;
		}
	}

	.statistics-boxes-wrap {
		@media (min-width: 768px) {
      display: flex;
		}
	}

	.statistics-box {
		flex-direction: column;
		flex: 1 33%;
	}

	.statistic-box-title {
		@media (min-width: 768px) {
			min-height: 4em;

			display: flex;

			flex-direction: column;

			align-content: flex-end;
			margin-bottom: 1em;
		}

	}

	.statistics-title h2 {
    width: 100%;
		margin-bottom: 0;
		line-height: 1;
	}

	.statistics-box h3,
	.statistics-box p {
		max-width: 25rem;
		text-align: left;

		@media (min-width: 768px) {
			margin-left: 1.5rem;
			margin-right: 1.5rem;
		}
	}

  .statistics-box p {
    margin-bottom: 1rem;
  }

	.statistics-box h3 {
		color: rgb(53, 211, 79);
		line-height: 1;
	}
	.statistics-box .big {
		font-weight: bold;
		letter-spacing: -1.2px;
		font-size: 35px;

		@media (min-width: 500px) {
			font-size: 38px;
		}

		@media (min-width: 1200px) {
			font-size: 48px;
		}
	}

	.statistics-box h2  {
		margin-top: auto;
	}

	.statistic-box-text {
		margin-bottom: 1em;

		@media (min-width: 768px) {
			border-left: 2px dotted white;
      min-height: 100%;
			margin-bottom: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// _source/javascript/components/statisticssection.vue